import {
    GENERATE_REPORTS, DOWNLOAD_TENANT_TRANSACTIONS_REPORT,
    DOWNLOAD_TRANSACTIONS, DOWNLOAD_TENANTS_REPORT,
    GENERATE_ARREARS_REPORTS, GENERATE_EXPENSES_REPORTS,
    GENERATE_MONTH_ON_MONTH_REPORTS, GENERATE_YEAR_ON_YEAR_REPORTS,
    GENERATE_PROPERTY_GROUPING_REPORT, GENERATE_MULTI_PROPERTY_REPORTS,
    GENERATE_DELETED_TENANTS_REPORT
} from './actionTypes';

const generateReports = ({propertyId, outputFormat, startDate, endDate, reportSettings}) => ({
    type: GENERATE_REPORTS,
    payload: {
        propertyId,
        outputFormat,
        startDate,
        endDate,
        reportSettings
    },
    errors: null
});

const generateMultiPropertyReports = ({
    propertyIds,
    outputFormat,
    startDate,
    endDate,
    reportSettings,
    allPropertiesSelected
}) => ({
    type: GENERATE_MULTI_PROPERTY_REPORTS,
    payload: {
        propertyIds,
        outputFormat,
        startDate,
        endDate,
        reportSettings,
        allPropertiesSelected
    },
    errors: null
});


const generateArrearsReports = ({propertyIds, outputFormat, startDate, endDate, reportSettings}) => ({
    type: GENERATE_ARREARS_REPORTS,
    payload: {
        propertyIds,
        outputFormat,
        startDate,
        endDate,
        reportSettings
    },
    errors: null
});

const generateExpensesReports = ({propertyId, outputFormat, startDate, endDate}) => ({
    type: GENERATE_EXPENSES_REPORTS,
    payload: {
        propertyId,
        outputFormat,
        startDate,
        endDate
    },
    errors: null
});

const generateMonthOnMonthReports = ({propertyId, outputFormat, startDate, endDate, chartGraph}) => ({
    type: GENERATE_MONTH_ON_MONTH_REPORTS,
    payload: {
        propertyId,
        outputFormat,
        startDate,
        endDate,
        chartGraph
    },
    errors: null
});

const generateYearOnYearReports = ({propertyId, outputFormat, startDate, endDate, chartGraph}) => ({
    type: GENERATE_YEAR_ON_YEAR_REPORTS,
    payload: {
        propertyId,
        outputFormat,
        startDate,
        endDate,
        chartGraph
    },
    errors: null
});

const generatePropertyGroupingReport = (payload)=>{
    return {
        type: GENERATE_PROPERTY_GROUPING_REPORT,
        payload,
        errors: null
    }
}

const generateDeletedTenantsReport = ({propertyId, tenantIds = [], outputFormat}) => ({
    type: GENERATE_DELETED_TENANTS_REPORT,
    payload: {
        propertyId,
        tenantIds,
        outputFormat
    },
    errors: null
});


const downloadTenantTransactionsReport = ({tenantId, outputFormat}) => ({
    type: DOWNLOAD_TENANT_TRANSACTIONS_REPORT,
    payload: {
        tenantId,
        outputFormat // Type to return can be csv_str, csv, pdf, excel

    },
    errors: null
});


const downloadTenantsReport = (params) => {
    const defaultParams = {
        propertyIds : [], maxBalance: "", minBalance: "", searchText: "",
        archived: "", daysToLeaseExpiry: "", tenantIds: [], sortField: "", sortOrder: ""
    };
    const combinedParams = { ...defaultParams, ...params}
    return ({
        type: DOWNLOAD_TENANTS_REPORT,
        payload: {
            ...combinedParams
        },
        errors: null
    })
}


const downloadTransactions = (transactionType, filters) => {
    return {
        type: DOWNLOAD_TRANSACTIONS,
        payload: {
            transactionType,
            filters
        },
        errors: null
    }
};

export {
    generateReports, generateMultiPropertyReports, downloadTenantTransactionsReport,
    downloadTransactions, downloadTenantsReport,
    generateArrearsReports, generateExpensesReports,
    generateMonthOnMonthReports, generateYearOnYearReports,
    generatePropertyGroupingReport, generateDeletedTenantsReport
}